export default {
      id: "imagePath-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#imagePath",
      toString: function () {
        return this.url;
      }
    }